import React from 'react'
import { useDebounce } from 'react-use'
import { useSearchParamsHandler } from '~/contexts/FilterContext'

export const useSearch = () => {
  const { query, setQueries } = useSearchParamsHandler()
  const [search, setSearch] = React.useState(query.search || '')
  useDebounce(
    () => {
      const page = query.page ? 1 : undefined
      const sort = query.sort ? '' : undefined
      const sortBy = query.sortBy ? '' : undefined
      setQueries({
        search: search,
        page,
        sort,
        sortBy,
      })
    },
    500,
    [search]
  )

  return { search, setSearch }
}
